<template>
  <div class="icon-container"
       :class="[type]"
       @click="onClick">
    <font-awesome-icon class="icon"
                       :icon="icon" />
  </div>
</template>

<style lang="scss" scoped>
.icon {
  width: 75%;
  height: 75%;
}

.icon-container {
  @include center-full;

  width: 2em;
  height: 2em;

  &.info {
    color: white;
    background: $blue;
  }
}
</style>

<script>
export default {
  name: "Icon",
  props: {
    icon: {
      type: String,
      require: true,
    },
    type: {
      type: String,
      default: "info",
    },
  },
  methods: {
    onClick() {
      this.$emit("click", null);
    },
  },
};
</script>